import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { couponService } from '@/api/services/couponService'

export function useCoupons(p?: Parameters<typeof couponService.list>[0]) {
  return useQuery({ queryKey: ['coupons', p], queryFn: () => couponService.list(p), staleTime: 30_000 })
}
export function useDeleteCoupon() {
  const qc = useQueryClient()
  return useMutation({ mutationFn: (id: number) => couponService.delete(id), onSuccess: () => qc.invalidateQueries({ queryKey: ['coupons'] }) })
}
export function useCreateUpdateCoupon() {
  const qc = useQueryClient()
  return useMutation({ mutationFn: (d: Record<string, unknown>) => couponService.createUpdate(d), onSuccess: () => qc.invalidateQueries({ queryKey: ['coupons'] }) })
}
